<template>
    <div class="bg-white sm:hidden relative">
        <div class="flex pt-4 justify-between px-4 pb-6">
            <RouterLink to="/dashboard">
                <LogoImage class="h-16 mb-4"/>
            </RouterLink>

            <div class="mt-2 mr-2 flex space-x-4">
                <Language icon-only position-class="right-0" class="pt-1"/>

                <Popover>
                    <PopoverButton class="p-2 inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                        <QrIcon icon="bars" class="h-8"/>
                    </PopoverButton>

                    <PopoverOverlay class="fixed inset-0 bg-black opacity-30 z-10"/>

                    <transition
                        enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1"
                        enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0"
                        leave-to-class="opacity-0 translate-y-1"
                    >
                        <PopoverPanel class="z-20 absolute left-1/2 mt-10 flex w-screen max-w-max -translate-x-1/2 px-4">
                            <div class="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
                                <div class="p-4">
                                    <div class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
                                        <div class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                            <QrIcon icon="gauge-max" class="h-6 w-6 text-gray-600 group-hover:text-brand"/>
                                        </div>
                                        <div>
                                            <QrLink
                                                to="/dashboard"
                                                class="font-semibold text-gray-900"
                                                :text="trans('menu.dashboard')"
                                                trans="menu.dashboard"
                                            />

                                            <QrParagraph
                                                class="mt-1 text-gray-600"
                                                :text="trans('menu.dashboard-description')"
                                                trans="menu.dashboard-description"
                                            />
                                        </div>
                                    </div>

                                    <div class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
                                        <div class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                            <QrIcon icon="qrcode" class="h-6 w-6 text-gray-600 group-hover:text-brand"/>
                                        </div>
                                        <div>
                                            <QrLink
                                                to="/create/product"
                                                class="font-semibold text-gray-900"
                                                :text="trans('menu.create-qr-code')"
                                                trans="menu.create-qr-code"
                                            />

                                            <QrParagraph
                                                class="mt-1 text-gray-600"
                                                :text="trans('menu.create-qr-code-description')"
                                                trans="menu.create-qr-code-description"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                                    <QrLink to="/user" class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100">
                                        <QrIcon icon="user-gear" class="h-5 w-5 flex-none text-gray-400"/>
                                        <QrParagraph :text="trans('menu.user')" trans="menu.user"/>
                                    </QrLink>

                                    <QrLink @click="userStore.logout" class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100">
                                        <QrIcon icon="arrow-right-from-bracket" class="h-5 w-5 flex-none text-gray-400"/>
                                        <QrParagraph :text="trans('menu.logout')" trans="menu.logout"/>
                                    </QrLink>
                                </div>
                            </div>
                        </PopoverPanel>
                    </transition>
                </Popover>
            </div>
        </div>

        <div class="bg-slate-200 absolute w-full h-7 rounded-t-3xl -bottom-1"/>
    </div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { useUserStore} from "@/store/user";
import { Popover, PopoverButton, PopoverOverlay, PopoverPanel } from '@headlessui/vue'
import { trans } from "@/libs/helper.js";
import { storeToRefs } from "pinia";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrLink from "@/components/application-ui/content/QrLink.vue";
import QrParagraph from "@/components/application-ui/content/QrParagraph.vue";
import Language from "@/components/Language.vue";
import LogoImage from "@/components/LogoImage.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
</script>
